/**
 * Group tag
 *
 * @category Group Entity
 * */
export class GroupTag {

  /**
   * Works as id
   * */
  slug: string;

  /**
   * Title, doh
   * */
  title: string;

  /**
   * Background color in not selected state.<br>
   * Values are from AppColorList
   * */
  background? = 'white';

  /**
   * Color in not selected state.<br>
   * Values are from AppColorList
   * */
  color? = 'text';

  /**
   * Background color in selected state.<br>
   * Values are from AppColorList
   * */
  selectedBackground? = 'text';

  /**
   * Color in selected state.<br>
   * Values are from AppColorList
   * */
  selectedColor? = 'white';
}

/**
 * Tags for all groups with count
 *
 * @category Group Entity
 * */
export class GroupsTag extends GroupTag {
  count = 0;
}
